<!--
 * @Author       : liushuai 944566598@qq.com
 * @Date         : 2023-11-23 11:05:30
 * @LastEditors: liushuai 944566598@qq.com
 * @LastEditTime: 2024-01-15 18:42:05
 * @FilePath: \nscfp-web\nanshaClimateInvest-manage\src\components\UpLoadProjectPlan.vue
 * @Description  : 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
-->
<template>
    <div>
        <p v-if="title != null && title != ''">{{ title }}</p>
        <p v-else>最大文件不超过 30 MB。</p>
        <el-upload style="display: inline-block;" multiple :file-list="fileList" :on-change="changeFormFileChange"
            :on-remove="changeFormFileRemove" :action="upload.url" :headers="upload.headers" :limit="6"
            :before-upload="changeFormBeforeAvatarUpload" :on-success="changeFormHandleFileSuccess"
            :on-exceed="changeFormHandleExceed" :on-preview="handlePreview">
            <el-button type="primary" plain>
                <i class="el-icon-upload el-icon--right"></i>点击选择文件
            </el-button>
        </el-upload>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import { autoFormApi } from '../api/api-url/autoForm'
export default {
    name: 'UpLoadProjectPlan',
    props: ['imgUrl', 'title', 'file'],
    data() {
        return {
            upload: {
                isUploading: false, // 是否禁用上传
                url: process.env.VUE_APP_URL + 'questionnaire/uploadFiles', // 请求地址
                headers: {
                    'X-CCXI-ADMIN-Token': Cookies.get('Authorization'),
                    // 'Content-Type': 'multipart/form-data'
                },  // 设置上传的请求头部
            },
            fileList: [],
            changeFileList: []
        }
    },
    watch: {
        imgUrl(val) {
            this.imgUrl = val
        },
        file(val) {
            this.file = val
        },
    },
    created() {
        console.log(this.file)
        // if (this.file.length > 0) {
        this.fileList = this.file
        // this.upload.data = 
        // }
    },
    mounted() { },
    methods: {
        changeFormBeforeAvatarUpload(file) {
            // console.log(file);
            // const isJPG = file.type === 'image/jpeg'
            //     || file.type === 'image/png'
            // if (!isJPG) {
            //     this.$message.error('上传文件只能是 JPG/PNG 格式!');
            //     return false
            // }
            const isLt2M = file.size / 1024 / 1024 < 30;
            if (!isLt2M) {
                this.$message.error('上传文件大小不能超过 30MB!');
                return isLt2M
            }
        },
        //检测文件变动获取文件
        changeFormFileChange(file, fileList) {
            this.changeFileList = fileList;
        },
        //检测文件删除
        changeFormFileRemove(file, fileList) {
            // console.log(file, fileList)
            // this.changeFileList = fileList.response.result.data;
            this.$emit('getIndex')
            if (fileList.length === 0) {
                this.$emit('changeFilePath', [])
            }
            let newArr = []
            fileList.forEach(item => {
                if (item.url) {
                    newArr.push({
                        url: item.url,
                        name: item.name
                    })
                } else {
                    newArr.push({
                        url: item.response.result.data[0].fileUrl,
                        name: item.response.result.data[0].fileName
                    })
                }
            })
            // this.changeForm.orgBackground = newArr
            // console.log(newArr);
            this.$emit('changeFilePath', newArr)
            this.$emit('blurSave')
        },
        changeFormHandleExceed() {
            //提示最多只能上传20个
            this.$message.error('最多上传6个文件！');
        },
        /** 文件上传成功处理 */
        changeFormHandleFileSuccess(response, file, fileList) {
            // console.log(response);
            // console.log(fileList);
            this.upload.isUploading = false;
            this.changeFileList = fileList;
            this.$message({
                message: '上传成功！',
                type: 'success'
            })
            let list = []
            fileList.forEach(item => {
                if (item.url) {
                    list.push({
                        url: item.url,
                        name: item.name
                    })
                } else {
                    list.push({
                        url: item.response.result.data[0].fileUrl,
                        name: item.response.result.data[0].fileName
                    })
                }
            })
            // console.log(list);
            this.$emit('getIndex')
            this.$emit('changeFilePath', list)
            this.$emit('blurSave')
        },
        async handlePreview(file) {
            // console.log(file)
            let fileUrl
            if (file.url) {
                fileUrl = file.url
            } else {
                fileUrl = file.response.result.data[0].fileUrl
            }
            const res = await autoFormApi.downloadFileApi({
                fileUrl
            })
            if (res.code === 1) {
                window.open(res.result.data)
            }
        }
    }
}
</script>

<style lang="scss">
// .upload-style {
//     display: flex;
//     justify-content: left;
//     // flex-direction: column;
//     width: 100%;
//     height: 100%;

//     .el-upload-list {
//         width: 360px;
//     }

//     .upload-img {
//         margin-left: 20px;
//         width: 360px;
//         height: 180px;
//     }
// }
</style>